import type { Country } from '@/models/country/types';

// В справочнике стран у Казахстана currency_code «тг.», а в интерфейсе нужен знак ₸.
const SIGN_BY_COUNTRY_CODE: Record<string, string> = { KZ: '₸' };

export const UNKNOWN_COUNTRY_LABEL = 'Страна не определена';

export function currencySign(country: Country | undefined): string {
  if (!country) return '';
  return SIGN_BY_COUNTRY_CODE[country.code] ?? country.currency_code;
}

export interface CountryGroup<T> {
  key: string;
  label: string;
  currency: string;
  items: T[];
}

// Деньги разных стран в разных валютах — итоги и графики считаются по каждой стране отдельно.
export function groupByCountry<T>(
  items: T[],
  countryOf: (item: T) => Country | undefined
): CountryGroup<T>[] {
  const groups = new Map<string, CountryGroup<T>>();
  for (const item of items) {
    const country = countryOf(item);
    const key = country?.id_country ?? '';
    let group = groups.get(key);
    if (!group) {
      group = {
        key,
        label: country?.name ?? UNKNOWN_COUNTRY_LABEL,
        currency: currencySign(country),
        items: [],
      };
      groups.set(key, group);
    }
    group.items.push(item);
  }
  // Порядок стабильный: страны по алфавиту, неопределённая — последней.
  return Array.from(groups.values()).sort((a, b) =>
    a.key === '' ? 1 : b.key === '' ? -1 : a.label.localeCompare(b.label, 'ru')
  );
}
